import { render } from "./ActivityRegistrationsManageView.vue?vue&type=template&id=01817418&scoped=true"
import script from "./ActivityRegistrationsManageView.vue?vue&type=script&lang=js"
export * from "./ActivityRegistrationsManageView.vue?vue&type=script&lang=js"

import "./ActivityRegistrationsManageView.vue?vue&type=style&index=0&id=01817418&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01817418"]])

export default __exports__